import React, {lazy, Suspense} from 'react'

const DocumentsPageLazy = lazy(() =>
    import('./DocumentsPage')
)

const DocumentsPage = props => (
    <Suspense fallback={null}>
        <DocumentsPageLazy {...props} />
    </Suspense>
)

export default DocumentsPage
